module.exports = __webpack_public_path__ + "static/media/fly0090.4df24693.webp";